import Helper from "../../Helper";
import { GateToDropoffRoute } from "../../models/GateToDropoffRoute";
import { MapObject } from "../../models/MapObject";
import { plotFetch } from "../Helper/ApiRequest";

interface GateToDropoffRouteFilters {
    gateId?: number;
    dropoffId?: number;
}

export function getProjectGateToDropoffRoutes(
    team_subdomain: string,
    project_token: string,
    timezone: string,
    filters: GateToDropoffRouteFilters = {}
): Promise<GateToDropoffRoute[]> {
    const url = new URL(
        `${Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects")}/projects/${project_token}/gate_to_dropoff_routes`
    );

    if (filters.gateId) url.searchParams.append("gate_id", filters.gateId.toString());
    if (filters.dropoffId) url.searchParams.append("dropoff_id", filters.dropoffId.toString());

    return plotFetch(url.toString(), { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response.map((route: any) => GateToDropoffRoute.fromApiObject(route, timezone));
        })
        .catch((_) => {
            return [];
        });
}

export function getProjectGateToDropoffRoute(
    team_subdomain: string,
    project_token: string,
    gate_to_dropoff_route_id: number,
    timezone: string
): Promise<GateToDropoffRoute | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/gate_to_dropoff_routes/${gate_to_dropoff_route_id}`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            if (response) {
                return GateToDropoffRoute.fromApiObject(response, timezone);
            }

            return null;
        })
        .catch((_) => {
            return null;
        });
}

export function createGateToDropoffRoute(
    team_subdomain: string,
    project_token: string,
    gateToDropoffRoute: GateToDropoffRoute,
    map_object: MapObject,
    timezone: string
): Promise<GateToDropoffRoute | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/gate_to_dropoff_routes`;

    return plotFetch(
        url,
        {
            method: "POST",
            body: JSON.stringify({
                gate_to_dropoff_route: gateToDropoffRoute.toApiObject(),
                map_object: map_object.toApiObject(),
            }),
        },
        true
    )
        .then(async (data) => {
            const jsonData = await data.json();
            if (!data.ok) {
                const errorMessage = jsonData.error || data.statusText;
                throw new Error(errorMessage);
            }
            return jsonData;
        })
        .then((data) => {
            return GateToDropoffRoute.fromApiObject(data, timezone);
        })
        .catch(() => {
            return null;
        });
}

export function deleteGateToDropoffRoute(
    team_subdomain: string,
    project_token: string,
    gateToDropoffRoute: GateToDropoffRoute
): Promise<boolean> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/gate_to_dropoff_routes/${gateToDropoffRoute.id}`;

    return plotFetch(url, { method: "DELETE" }, true)
        .then((response) => {
            if (response.ok) {
                return true;
            }
            throw new Error("Network error.");
        })
        .catch(() => {
            return false;
        });
}

export function updateGateToDropoffRoute(
    team_subdomain: string,
    projectToken: string,
    gateToDropoffRoute: GateToDropoffRoute,
    timezone: string
): Promise<GateToDropoffRoute | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${projectToken}/gate_to_dropoff_routes/${gateToDropoffRoute.id}`;

    return plotFetch(url, {
        method: "PUT",
        body: JSON.stringify({ gate_to_dropoff_route: gateToDropoffRoute.toApiObject() }),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            if (response) {
                return GateToDropoffRoute.fromApiObject(response, timezone);
            }

            return null;
        })
        .catch((_) => {
            return null;
        });
}
